
// Handle the cart items quantity update
const open = window.XMLHttpRequest.prototype.open;

function openReplacement() {
  this.addEventListener("load", function() {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      updateCart(this.response);
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

function updateCart(cartJson) {
    const cartQuantity = document.getElementById("cart__qty");
    const quantity = JSON.parse(cartJson).item_count;
    freeShippingProgress(JSON.parse(cartJson));
    if ( cartQuantity ){
        cartQuantity.innerHTML = '(' + quantity + ')';
        if (quantity > 0) {
            cartQuantity.classList.add('cart-link--visible');
        } else {
            cartQuantity.classList.remove('cart-link--visible');
        }
    }


}

(function(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function() {
    const response = fetch.apply(this, arguments);

    response.then(res => {
      if ([
          `${window.location.origin}/cart/add.js`,
          `${window.location.origin}/cart/update.js`,
          `${window.location.origin}/cart/change.js`,
          `${window.location.origin}/cart/clear.js`,
        ].includes(res.url)) {
        res.clone().json().then(data => {
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cartJson => {
                const cartQuantity = document.getElementById("cart__qty");
                const quantity = cartJson.item_count;
                freeShippingProgress(cartJson);
                cartQuantity.innerHTML = '(' + quantity + ')'
                if ( cartQuantity ){
                    cartQuantity.innerHTML = '(' + quantity + ')';
                    if (quantity > 0) {
                        cartQuantity.classList.add('cart-link--visible');
                    } else {
                        cartQuantity.classList.remove('cart-link--visible');
                    }
                }

            });
        });
      }
    });

    return response;
  }
}(window, window.fetch));

function freeShippingProgress(cartJson) {
    if ( cartJson.total_price !== 0 ) {
        const totalPrice = cartJson.total_price / 100;

        let difference = 60;
        let progressMessage = "";

        const cartHeader = document.querySelector('.drawer__fixed-header');
        if (totalPrice < 60) {
            difference -= totalPrice;
            progressMessage = "You're $" + difference.toFixed(2) + " away from<br>free shipping.";
        } else {
            progressMessage = "Congrats! You get free<br> standard shipping!";
        }
        // append html
        const ProgressBox = document.getElementById('ProgressBox');
        if (ProgressBox) {
            ProgressBox.remove();
        }
        cartHeader.innerHTML += `<div id="ProgressBox"
                     style="border-bottom: 1px solid #fff; margin-top: 10px; ">
                    <p id="progressMessage" className="caption-large" style="text-align: center; "> ${progressMessage}
                    </p>
                </div>`;
        const ProgressBoxStyle = document.getElementById('ProgressBoxStyle');
        if (ProgressBoxStyle) {
            ProgressBoxStyle.remove();
        }
        const style = document.createElement('style');
        style.id = 'ProgressBoxStyle';
        style.innerHTML = `
            .ajaxcart__inner--has-fixed-footer {
                padding: 20px 30px 0;
            }
            .drawer__inner {
                top: 157px;
            }
`;
        document.head.appendChild(style);

    }else{
        const ProgressBox = document.getElementById('ProgressBox');
        if (ProgressBox) {
            ProgressBox.remove();
        }
        const ProgressBoxStyle = document.getElementById('ProgressBoxStyle');
        if (ProgressBoxStyle) {
            ProgressBoxStyle.remove();
        }
    }
}